// import React, { useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation, useNavigate } from "react-router-dom";
// import { logoutUser } from "../../redux/actions/authActions";
// import { HandleClearAllFilterFromStore } from "../../redux/store/storeHelper";
// import { PROFILE_MENU_CONTENT } from "../../utils/constants";
// import { BASE, BORDER, GREY, PRIMARY } from "../../utils/constants/colors";
// import { LOGIN_PATH, PROFILE_PATH } from "../../utils/constants/routes";
// import { fontSize, fontWeight } from "../../utils/constants/UI";
// import AvatarName from "../Avatar/AvatarName";
// import CustomBreadcrumbs from "../Breadcrumbs/Breadcrumbs";
// import IconComponent from "../Icon/IconComponent";
// import CustomStyledMenu from "../Menu/CustomStyledMenu";
// import { innerBottomBorder, innerLeftBorder } from "../../utils/helpers";
// import ContactFormModal from "../Modals/ContactFormModal";
// import { Mixpanel } from "../../Apis/Mixpanel";
// import { Box } from "@mui/material";
// import TypographyInline from "../Typography/TypographyInline";
// import { STRINGS } from "../strings";

// const styles = {
//   headerContainer: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     padding: "16px",
//     boxShadow: innerBottomBorder(BORDER.LIGHT),
//     backgroundColor: BASE.WHITE,
//     height: "64px",
//   },
//   bugReportContainer: {
//     display: "flex",
//     alignItems: "center",
//     cursor: "pointer",
//     gap: "4px",
//   },
//   headerRightContainer: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     gap: "8px",
//   },
//   userContainer: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     width: "100%",
//     cursor: "pointer",
//     paddingLeft: "12px",
//     borderLeft: `1px solid ${BORDER.LIGHT}`,
//   },
//   labelContainer: {
//     display: "flex",
//     flexDirection: "row",
//     alignItems: "center",
//     gap: "4px",
//     padding: "12px 16px",
//     cursor: "pointer",
//     "&:hover": {
//       backgroundColor: BASE.BACKGROUND_LIGHT,
//       boxShadow: innerLeftBorder(PRIMARY.W_500),
//     },
//   },
//   creditContainer: {
//     display: "flex",
//     alignItems: "center",
//     gap: "4px",
//   },
//   headerSubContainer: {
//     display: "flex",
//     gap: "50px",
//     alignItems: "center",
//   },
// };

// const CustomHeader = ({ items = [], description = "", children }) => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const userDetailsSelector = useSelector((state) => state?.userDetails);
//   const [openConfirmation, setOpenConfirmation] = useState(false);

//   const userDetails = userDetailsSelector?.payload;
//   const [isProfileClicked, setIsProfileClicked] = useState(false);
//   const [profileAnchor, setProfileAnchor] = useState(null);

//   const handleProfileNavigation = async () => {
//     sessionStorage.clear();
//     HandleClearAllFilterFromStore(dispatch, location, navigate);
//     navigate(`${PROFILE_PATH}?tab=General`);
//   };

//   const handleLogout = async (each) => {
//     if (each?.title === "Logout") {
//       await dispatch(logoutUser());
//       Mixpanel.track(" logout Successfully");
//       navigate(LOGIN_PATH);
//     }

//     if (each?.title === "Settings") {
//       handleProfileNavigation();
//     }
//   };

//   const toolTipTitle = (
//     <div>
//       {PROFILE_MENU_CONTENT.map((each, index) => {
//         if (each.id === "available_credits") {
//           return (
//             <Box key={index} sx={styles.labelContainer}>
//               <IconComponent
//                 iconLabel={each?.icon}
//                 color={GREY.SECONDARY}
//                 fontSize={fontSize.LG}
//               />
//               <div style={styles.creditContainer}>
//                 <TypographyInline
//                   color={GREY.SECONDARY}
//                   fontWeight={fontWeight.REGULAR}
//                   label={each?.title}
//                   size="sm"
//                 />
//                 <TypographyInline
//                   color={PRIMARY.W_500}
//                   fontWeight={fontWeight.REGULAR}
//                   label={userDetails?.[each?.id] || 0}
//                   size="sm"
//                 />
//               </div>
//             </Box>
//           );
//         }
//         return (
//           <Box
//             onClick={() => handleLogout(each)}
//             key={each.title}
//             sx={styles.labelContainer}
//           >
//             <IconComponent
//               iconLabel={each?.icon}
//               color={GREY.SECONDARY}
//               fontSize={fontSize.LG}
//             />
//             <TypographyInline
//               color={GREY.SECONDARY}
//               fontWeight={fontWeight.REGULAR}
//               label={each?.title}
//               size="sm"
//             />
//           </Box>
//         );
//       })}
//     </div>
//   );

//   const handleProfileClick = (event) => {
//     setProfileAnchor(event.currentTarget);
//     setIsProfileClicked(true);
//   };

//   const handleProfileCloseHandler = () => {
//     setIsProfileClicked(false);
//     setProfileAnchor(null);
//   };

//   return (
//     <div style={styles.headerContainer}>
//       {/* Header Left Part */}
//       <div style={styles.headerSubContainer}>
//         <div>
//           <CustomBreadcrumbs items={items} />
//           {description?.trim()?.length ? (
//             <TypographyInline
//               label={description}
//               size={"xs"}
//               color={GREY.SECONDARY}
//               fontWeight={fontWeight.REGULAR}
//             />
//           ) : null}
//         </div>

//         {/* children is right part of breadcrumbs */}
//         {children ? <div>{children}</div> : null}
//       </div>
//       {/* Header Left Part */}
//       {/* Header Right Part */}
//       <div style={styles.headerRightContainer}>
//         <div style={styles.userContainer} onClick={handleProfileClick}>
//           <AvatarName
//             size={"small"}
//             name={
//               userDetails
//                 ? userDetails?.first_name + " " + userDetails?.last_name
//                 : STRINGS.LOADING
//             }
//           />
//         </div>
//         <CustomStyledMenu
//           open={isProfileClicked}
//           anchorEl={profileAnchor}
//           onClose={handleProfileCloseHandler}
//           noMargin={true}
//         >
//           {toolTipTitle}
//         </CustomStyledMenu>

//         <ContactFormModal
//           open={openConfirmation}
//           setOpen={setOpenConfirmation}
//         />
//       </div>
//       {/* Header Right Part */}
//     </div>
//   );
// };

// export default CustomHeader;

// // ------------- NOTE ----------------
// // Props Description:-
// // items :- It should be array of object and every object should have three keys - id, label and path. If you want to display only label then don't pass path in the object only pass id and label for that.
// // description :- Label you want to display under header Heading.
// // dropdownItems :- DropdownItems have four keys - items,onchange function,initialValue,initialId,isEmpty,buttondetails -label,variant,lefticon,onclick you want to display in the header

import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { logoutUser } from "../../redux/actions/authActions";
import { HandleClearAllFilterFromStore } from "../../redux/store/storeHelper";
import { PROFILE_MENU_CONTENT } from "../../utils/constants";
import { BASE, BORDER, GREY, PRIMARY } from "../../utils/constants/colors";
import { LOGIN_PATH, PROFILE_PATH } from "../../utils/constants/routes";
import { fontSize, fontWeight } from "../../utils/constants/UI";
import AvatarName from "../Avatar/AvatarName";
import CustomBreadcrumbs from "../Breadcrumbs/Breadcrumbs";
import IconComponent from "../Icon/IconComponent";
import CustomStyledMenu from "../Menu/CustomStyledMenu";
import { innerBottomBorder, innerLeftBorder } from "../../utils/helpers";
import ContactFormModal from "../Modals/ContactFormModal";
import { Mixpanel } from "../../Apis/Mixpanel";
import { Box, Divider } from "@mui/material";
import TypographyInline from "../Typography/TypographyInline";
import { STRINGS } from "../strings";
import { ICON_LABELS } from "../../utils/constants/UI";

const styles = {
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px",
    boxShadow: innerBottomBorder(BORDER.LIGHT),
    backgroundColor: BASE.WHITE,
    height: "64px",
  },
  // Reusable style for clickable icons in the header
  iconButtonContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    padding: "4px",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    "&:hover": {
      backgroundColor: BASE.BACKGROUND_LIGHT,
    },
  },
  headerRightContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "4px",
  },
  userContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    cursor: "pointer",
    paddingLeft: "12px",
    borderLeft: `1px solid ${BORDER.LIGHT}`,
  },
  labelContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "4px",
    padding: "12px 16px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: BASE.BACKGROUND_LIGHT,
      boxShadow: innerLeftBorder(PRIMARY.W_500),
    },
  },
  notificationItemContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "12px 16px",
    gap: "4px",
    borderBottom: `1px solid ${BORDER.LIGHT}`,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: BASE.BACKGROUND_LIGHT,
    },
  },
  creditContainer: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  headerSubContainer: {
    display: "flex",
    gap: "50px",
    alignItems: "center",
  },
};

const CustomHeader = ({ items = [], description = "", children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userDetailsSelector = useSelector((state) => state?.userDetails);

  // State for Bug Report Modal
  const [openConfirmation, setOpenConfirmation] = useState(false);

  // State for Notification Menu
  const [isNotificationClicked, setIsNotificationClicked] = useState(false);
  const [notificationAnchor, setNotificationAnchor] = useState(null);

  const userDetails = userDetailsSelector?.payload;
  const [isProfileClicked, setIsProfileClicked] = useState(false);
  const [profileAnchor, setProfileAnchor] = useState(null);

  // Mock Data for Notifications (Replace with actual data if available)
  const notifications = [
    { id: 1, title: "New Campaign Created", time: "2 mins ago" },
    { id: 2, title: "User Login Alert", time: "1 hour ago" },
    { id: 3, title: "Weekly Report Ready", time: "5 hours ago" },
  ];

  const handleModalChange = () => {
    setOpenConfirmation(!openConfirmation);
  };

  const handleNotificationClick = (event) => {
    setNotificationAnchor(event.currentTarget);
    setIsNotificationClicked(true);
  };

  const handleNotificationClose = () => {
    setIsNotificationClicked(false);
    setNotificationAnchor(null);
  };

  const handleProfileNavigation = async () => {
    sessionStorage.clear();
    HandleClearAllFilterFromStore(dispatch, location, navigate);
    navigate(`${PROFILE_PATH}?tab=General`);
  };

  const handleLogout = async (each) => {
    if (each?.title === "Logout") {
      await dispatch(logoutUser());
      Mixpanel.track(" logout Successfully");
      navigate(LOGIN_PATH);
    }

    if (each?.title === "Settings") {
      handleProfileNavigation();
    }
  };

  const toolTipTitle = (
    <div>
      {PROFILE_MENU_CONTENT.filter((item) => {
        if (
          userDetails?.role_access === "admin-sdr" &&
          item.title === "Settings"
        ) {
          return false;
        }
        return true;
      }).map((each, index) => {
        if (each.id === "available_credits") {
          const isSdr =
            userDetails?.isSdr === true || userDetails?.isSdr === "true";
          return (
            <Box key={index} sx={styles.labelContainer}>
              <IconComponent
                iconLabel={each?.icon}
                color={GREY.SECONDARY}
                fontSize={fontSize.LG}
              />
              <div style={styles.creditContainer}>
                <TypographyInline
                  color={GREY.SECONDARY}
                  fontWeight={fontWeight.REGULAR}
                  label={each?.title}
                  size="sm"
                />
                <TypographyInline
                  color={PRIMARY.W_500}
                  fontWeight={fontWeight.REGULAR}
                  label={isSdr ? "Unlimited" : (userDetails?.[each?.id] || 0)}
                  size="sm"
                />
              </div>
            </Box>
          );
        }
        return (
          <Box
            onClick={() => handleLogout(each)}
            key={each.title}
            sx={styles.labelContainer}
          >
            <IconComponent
              iconLabel={each?.icon}
              color={GREY.SECONDARY}
              fontSize={fontSize.LG}
            />
            <TypographyInline
              color={GREY.SECONDARY}
              fontWeight={fontWeight.REGULAR}
              label={each?.title}
              size="sm"
            />
          </Box>
        );
      })}
    </div>
  );

  const notificationContent = (
    <div>
      {notifications.length > 0 ? (
        notifications.map((item) => (
          <Box key={item.id} sx={styles.notificationItemContainer}>
            <TypographyInline
              label={item.title}
              color={BASE.BLACK}
              fontWeight={fontWeight.MEDIUM}
              size="sm"
            />
            <TypographyInline
              label={item.time}
              color={GREY.SECONDARY}
              fontWeight={fontWeight.REGULAR}
              size="xs"
            />
          </Box>
        ))
      ) : (
        <Box sx={styles.notificationItemContainer}>
          <TypographyInline
            label="No new notifications"
            color={GREY.SECONDARY}
            size="sm"
          />
        </Box>
      )}
    </div>
  );

  const handleProfileClick = (event) => {
    setProfileAnchor(event.currentTarget);
    setIsProfileClicked(true);
  };

  const handleProfileCloseHandler = () => {
    setIsProfileClicked(false);
    setProfileAnchor(null);
  };

  return (
    <div style={styles.headerContainer}>
      {/* Header Left Part */}
      <div style={styles.headerSubContainer}>
        <div>
          <CustomBreadcrumbs items={items} />
          {description?.trim()?.length ? (
            <TypographyInline
              label={description}
              size={"xs"}
              color={GREY.SECONDARY}
              fontWeight={fontWeight.REGULAR}
            />
          ) : null}
        </div>

        {/* children is right part of breadcrumbs */}
        {children ? <div>{children}</div> : null}
      </div>
      {/* Header Left Part */}
      {/* Header Right Part */}
      <div style={styles.headerRightContainer}>
        {/* --- Report a Bug Section --- */}
        <Box onClick={handleModalChange} sx={styles.iconButtonContainer}>
          <IconComponent
            iconLabel={ICON_LABELS.HELP_OUTLINE}
            color={GREY.TERTIARY}
          />
        </Box>
        {/* --- End Report a Bug Section --- */}

        {/* --- Notification Section --- */}
        {/* <Box onClick={handleNotificationClick} sx={styles.iconButtonContainer}>
          <IconComponent
            iconLabel={ICON_LABELS.NOTIFICATIONS_NONE}
            color={GREY.TERTIARY}
          />
        </Box> */}
        {/* --- End Notification Section --- */}

        <div data-tour="user-avatar-btn" style={styles.userContainer} onClick={handleProfileClick}>
          <AvatarName
            size={"small"}
            name={
              userDetails
                ? userDetails?.first_name + " " + userDetails?.last_name
                : STRINGS.LOADING
            }
          />
        </div>

        {/* Profile Menu */}
        <CustomStyledMenu
          open={isProfileClicked}
          anchorEl={profileAnchor}
          onClose={handleProfileCloseHandler}
          noMargin={true}
          MenuListProps={{ 'data-tour': 'user-profile-dropdown' }}
        >
          {toolTipTitle}
        </CustomStyledMenu>

        {/* Notification Menu */}
        <CustomStyledMenu
          open={isNotificationClicked}
          anchorEl={notificationAnchor}
          onClose={handleNotificationClose}
          width={"250px"} // Adjust width as needed
        >
          {notificationContent}
        </CustomStyledMenu>

        {/* Bug Report Modal */}
        <ContactFormModal
          open={openConfirmation}
          setOpen={setOpenConfirmation}
        />
      </div>
      {/* Header Right Part */}
    </div>
  );
};

export default CustomHeader;

// ------------- NOTE ----------------
// Props Description:-
// items :- It should be array of object and every object should have three keys - id, label and path. If you want to display only label then don't pass path in the object only pass id and label for that.
// description :- Label you want to display under header Heading.
// dropdownItems :- DropdownItems have four keys - items,onchange function,initialValue,initialId,isEmpty,buttondetails -label,variant,lefticon,onclick you want to display in the header
